import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles } from '@/js/libs/use-auth';

import Status from 'src/scenes/Status';
import Targeting from 'src/scenes/Targeting';

const index = true;

export const targetingRouteObject = inferRouteObject({
  path: 'targeting',
  element: <PrivateRoute roles={Roles.CONTEXTUAL} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: Targeting.Helmet,
      children: [
        {
          Component: Targeting.Layout,
          children: [
            {
              element: <PrivateRoute roles={Roles.CONTEXTUAL} noAccessComponent={Status.NotFound} />,
              children: [
                { index, element: <Navigate to='./keywords' replace /> },
                {
                  path: 'keywords',
                  children: [
                    { index, Component: Targeting.ConfigsTargeting },
                    {
                      path: 'config',
                      children: [
                        { index, Component: Targeting.KeywordsTargeting },
                        { path: ':configId', Component: Targeting.KeywordsTargeting },
                      ],
                    },
                  ],
                },
                { path: 'default-values', Component: Targeting.DefaultValues },
              ],
            },
            {
              element: <PrivateRoute roles={Roles.ADMIN} noAccessComponent={Status.NotFound} />,
              children: [
                {
                  path: 'segments',
                  children: [
                    { index, Component: Targeting.SegmentsTargeting },
                    { path: 'new', Component: Targeting.NewSegmentsTargeting },
                    { path: ':segmentName', Component: Targeting.NewSegmentsTargeting },
                  ],
                },
              ],
            },
          ],
        },
        {
          element: <PrivateRoute roles={Roles.ADMIN} noAccessComponent={Status.NotFound} />,
          children: [{ path: 'visitor-segments', Component: Targeting.VisitorSegments }],
        },
      ],
    },
  ],
});
